import { KeyStatus } from '@anchorage/graphql/generated';

type UserKeyInfo = {
  __typename: string;
  keyInfo?: {
    id: string;
    status: KeyStatus;
  };
};

export type UserWithKeys = {
  keys: {
    edges: Array<{
      node: UserKeyInfo | null;
    }>;
  };
};

/*
 * Mirrors `VALID_KEY_STATUSES` / `isValidKeyStatus` from `@domains/policies`
 * (the canonical source of truth — UNUSED is included per INC-4968). It is
 * duplicated here because `@domains/policies` depends on `@anchorage/frontoffice`,
 * so importing the helper would create a circular dependency. Keep the two in
 * sync until this util is migrated out of the legacy frontoffice package.
 */
const VALID_KEY_STATUS = [
  KeyStatus.USED.toString(),
  KeyStatus.UNUSED.toString(),
];

/** Extract the first active key ID from a UserV2's keys connection */
export const getUserActiveKey = <T extends UserWithKeys>(
  user: T,
): string | undefined => {
  const [activeKey] =
    user.keys?.edges
      ?.map((edge) => edge.node)
      .filter((node) => node !== null)
      .filter(
        (node) =>
          node?.__typename === 'UserKey' &&
          VALID_KEY_STATUS.includes(node?.keyInfo?.status ?? ''),
      ) || [];

  return activeKey?.keyInfo?.id;
};
